import React, { useEffect, useState, useCallback } from "react";
import MuiButton from "../../components/muiButton/MuiButton";
import DataGridFunction from "../../components/datagridComponent/datagrid";
import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import PostPlusButton from "../../components/postPlusButton/PostPlusButton";
import AutoCompleteComponent from "../../components/autoCompleteComponent/Autocomplete";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import { connect } from "react-redux";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import PostInfluencersPlatformAccounts from "./PostInfluencersPlatformAccounts";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
import InfluencerPlatformAction from "../../stores/influencerPlatformAccounts/InfluencerPlatformAction";
import jwtDecode from "jwt-decode";

const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [
    InfluencerPlatformAction.REQUEST_INFLUENCER_PLATFORM,
    InfluencerUserAction.REQUEST_INFLUENCER_USER,
  ]),
  influencerPlatformAccounts:
    state.influencerPlatformAccounts.influencerPlatformAccounts || [],
  influencerUser: state.influencerUser.influencerUser || [],
  pagination: state.influencerPlatformAccounts.influencerPlatformAccounts || [],
});

export const Created_on = '[["created_on", "desc"]]';

function InfluencersPlatformAccount(props) {
  const { isRequesting } = props;
  const [selectedInfluencer, setSelectedInfluencer] = useState(null);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [page_limit] = useState(15);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [filterLoader, setFilterLoader] = useState(false);
  const [clearLoader, setClearLoader] = useState(false);
  const [FilterClicked, setFilterClicked] = useState(false);

  useEffect(() => {
    if (!isRequesting) {
      setFilterLoader(false);
      setClearLoader(false);
    }
  }, [isRequesting]);

  function fetchInfluenceUser() {
    let params = {
      page_limit: "none",
      order_by: '[["created_on", "desc"]]',
    };
    props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
  }

  function fetchInfluencerPlatformAccounts(params) {
    props.dispatch(InfluencerPlatformAction.requestInfluencerPlatforms(params));
  }

  // useeffect get method
  useEffect(() => {
    const param = {
      order_by: Created_on,
      page_limit: `${page_limit}`,
    };

    // fetchInfluencerPlatformAccounts(param);
    fetchInfluenceUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function InfluencerFilterpush(value) {
    return `["influencer.influencer_id.keyword","must","","match","${value}"]`;
  }

  const filterArray = [];

  // pushing client name into filter array
  if (selectedInfluencer !== null) {
    filterArray.push(InfluencerFilterpush(selectedInfluencer.influencer_id));
  }

  // pagination
  const handleChange = (event, value) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    let filter_params = {};

    if (selectedInfluencer !== null && FilterClicked) {
      filter_params = {
        order_by: Created_on,
        filters: `[${filterArray}]`,
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
      };
    } else {
      filter_params = {
        order_by: Created_on,
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
      };
    }
    if (value - 1 !== props.pagination.current_page_no) {
      fetchInfluencerPlatformAccounts(filter_params);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "SL NO",
      width: 150,
      flex: 2,
      resizable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "influencer_accounts_unique_id",
      headerName: "ID",
      width: 200,
      hide: true,
    },

    {
      field: "influencer",
      headerName: "Influencer Name",
      width: 250,
      flex: 4,
    },

    {
      field: "account_name",
      headerName: "Account name",
      width: 250,
      flex: 4,
      resizable: false,
    },

    {
      field: "platform",
      headerName: "Platform",
      width: 250,
      flex: 4,
      resizable: false,
    },

    {
      field: "last_sync_date",
      headerName: "Last sync date",
      width: 250,
      flex: 4,
      resizable: false,
    },

    {
      field: "LoggedIn",
      headerName: "Logged In",
      width: 250,
      flex: 4,
      resizable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Edit",
      resizable: false,
      width: 160,
      flex: 2,
      cellClassName: "actions",
      renderCell: (params) => (
        <IconButton
          title="Edit"
          sx={{ border: "0" }}
          onClick={(event) => {
            event.ignore = true;
            setEditRowsModel(params.row);
            setEdit(true);
            setOpen(true);
          }}
        >
          <FontAwesomeIcon
            icon={faPenToSquare}
            style={{ height: "20px", width: "20px", color: "#2a5e6c" }}
          ></FontAwesomeIcon>
        </IconButton>
      ),
    },
  ];

  // datagrid rows
  const rows = [];
  if (props.influencerPlatformAccounts) {
    props.influencerPlatformAccounts.hits &&
      props.influencerPlatformAccounts.hits.hits &&
      props.influencerPlatformAccounts.hits.hits.length > 0 &&
      props.influencerPlatformAccounts.hits.hits.map((item, index) => {
        return rows.push({
          id: item._id
            ? props.pagination.current_page_no * page_limit + ++index
            : "",
          influencer_accounts_unique_id: item._id,
          influencer: item._source.influencer.influencer_name,
          account_name: item._source.account_name,
          platform: item._source.platform.platform_name,
          last_sync_date: (function createdDate() {
            let created = item._source.last_sync_date;
            let dateConversion = new Date(created);
            dateConversion =
              dateConversion.toDateString() +
              ", " +
              dateConversion.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              });

            return dateConversion;
          })(),
          rowData: item,
        });
      });
  }

  // post model dialog
  const openCloseModal = useCallback((open) => {
    setOpen(open);
  }, []);

  // edit model dialog
  const editMode = useCallback((edit) => {
    setEdit(false);
  }, []);

  let influencer;
  let platformList = [];

  if (props.influencerUser.hits?.hits[0]?._source) {
    props.influencerUser.hits?.hits[0]?._source.social_media_platforms.map(
      (item) => {
        platformList.push({
          platform_id: item.platform_id,
          platform_name: item.platform_name,
        });
      }
    );
  }

  return (
    <React.Fragment>
      <PostInfluencersPlatformAccounts
        influencerFilter={props.influencerUser}
        influencerData={influencer}
        platformList={platformList}
        open={open}
        onSubmit={() => {}}
        onClose={() => {
          setOpen(false);
        }}
        influencerPlatformEditData={editRowsModel}
        edit={edit}
      />

      <Grid container>
        <Grid
          container
          lg={12}
          md={12}
          sm={12}
          spacing={1}
          justifyContent="center"
        >
          <Grid>
            {/* post button component*/}
            <PostPlusButton
              open={open}
              openCloseModal={openCloseModal}
              editMode={editMode}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* data grid */}
      <Grid
        display="flex"
        justifyContent="center"
        container
        item
        lg={12}
        md={12}
        sm={12}
        mt={2}
      >
        {" "}
        <Grid item lg={10} md={12} sm={12} xs={12}>
          {/* loading icon */}
          <LoadingIndicator isActive={isRequesting}>
            {props.influencerPlatformAccounts.hits && (
              <DataGridFunction
                columns={columns}
                rows={rows}
                rowHeight={60}
                pagelength={props.pagination.total_page_no}
                page={props.pagination.current_page_no}
                handleChange={handleChange}
              />
            )}
          </LoadingIndicator>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(InfluencersPlatformAccount);
